import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
// import Sidebar from "../../../Sidebar/Sidebar"
import TestSheetComp from "./Component/TestSheetComp"

const TestSheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            {/* <Sidebar /> */}
             <TestSheetComp/>
        </div>
        <Footer />
        </>
    )
}

export default TestSheet